// components/EquipmentData.js
import React, { useEffect, useState } from 'react';

// import styled from 'styled-components';
import {
  TextField,
  ListItem,
  ListItemText,
  Stack,
  Typography,
  Autocomplete,
  Button,
  List,
  Box,
  Divider,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import { getGenericData } from '../../api';

const styleTextField = {
  backgroundColor: 'white',
  width: '30vw',
  '@media screen and (max-width: 600px)': {
    width: '70vw', // Width de 100% para telas de celulares
  },
};

function ServiceData({ formData, setFormData, dadosImportados }) {
  const [servicoSelecionado, setServicoSelecionado] = useState(null);
  const [quantidade, setQuantidade] = useState(1);
  const [servicos, setServicos] = useState([]);

  useEffect(() => {
    const getServicos = async () => {
      const result = await getGenericData('servico', {ativo:true});
      setServicos(result);
    };
    getServicos();
  }, []);

  const handleAdicionarServico = () => {
    if (!servicoSelecionado || quantidade <= 0) {
      // Adicionar feedback para o usuário, se desejar
      return;
    }

    const novoServico = {
      ...servicoSelecionado,
      quantidade,
    };

    setFormData((prev) => ({
      ...prev,
      servicos: [...(prev.servicos ?? []), novoServico],
    }));

    // Limpar campos após adicionar
    setServicoSelecionado(null);
    setQuantidade(1);
  };

  const handleRemoverServico = (index) => {
    setFormData((prev) => ({
      ...prev,
      servicos: prev.servicos.filter((_, i) => i !== index),
    }));
  };

  useEffect(() => {
    if (formData.servicos?.length === 0) return;
    const newDeslocamento = (formData.kmRodado || 0) * 2;
    const newSubTotalServicos = formData.servicos?.reduce(
      (total, servico) => total + servico.valor * servico.quantidade,
      0
    );
    const newValorServico = newDeslocamento + newSubTotalServicos;

    setFormData((prev) => ({
      ...prev,
      valorDeslocamento: newDeslocamento,
      subTotalServicos: newSubTotalServicos,
      valorServico: newValorServico,
    }));
  }, [formData.kmRodado, formData.servicos, setFormData]);

  return (
    <div>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={'flex-start'}
        justifyContent={'center'}
        flex={1}
        gap={3}
        p={2}
        backgroundColor={'white'}
        borderRadius={2}
      >
        {/* Lado Esquerdo: Inserção de Itens */}
        {!dadosImportados && !formData.visualiza && (
          <Stack
            alignItems={'center'}
            sx={{
              width: { xs: '100%', md: '50%' },
              border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              p: 3,
            }}
            gap={2}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Adicionar Serviços
            </Typography>

            <Autocomplete
              fullWidth
              options={servicos}
              getOptionLabel={(option) => option.nome}
              value={servicoSelecionado}
              onChange={(event, newValue) => {
                setServicoSelecionado(newValue);
              }}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              renderInput={(params) => <TextField {...params} label="Selecione o Serviço" />}
            />

            <Stack direction="row" gap={2} width="100%">
              <TextField
                label="Quantidade"
                type="number"
                value={quantidade}
                onChange={(e) => setQuantidade(Number(e.target.value))}
                InputProps={{ inputProps: { min: 1 } }}
                sx={{ width: '50%' }}
              />
              <TextField
                label="Valor Unitário (R$)"
                type="text"
                value={servicoSelecionado ? servicoSelecionado.valor.toFixed(2) : '0.00'}
                InputProps={{
                  readOnly: true,
                }}
                sx={{ width: '50%' }}
              />
            </Stack>

            <Button variant="contained" onClick={handleAdicionarServico} disabled={!servicoSelecionado}>
              Adicionar à Proposta
            </Button>
            <TextField
              size="small"
              id="kmrodado"
              label="KM Rodaddo"
              value={formData.kmRodado}
              inputProps={{ type: 'number' }}
              sx={styleTextField}
              onChange={(e) => {
                setFormData((prev) => ({ ...prev, kmRodado: e.target.value }));
              }}
            />
          </Stack>
        )}

        {/* Lado Direito: Itens Adicionados e Total */}
        <Stack
          sx={{
            width: { xs: '100%', md: '50%' },
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            p: 3,
            minHeight: '250px',
          }}
        >
          <Typography variant="h6" sx={{ mb: 1 }}>
            Serviços na Proposta
          </Typography>
          <List>
            {formData.servicos?.length > 0 ? (
              formData.servicos.map((servico, index) => {
                const subtotal = servico.valor * servico.quantidade;
                return (
                  <ListItem
                    key={index}
                    disableGutters
                    secondaryAction={
                      !dadosImportados &&
                      !formData.visualiza && (
                        <IconButton edge="end" aria-label="delete" onClick={() => handleRemoverServico(index)}>
                          <DeleteIcon />
                        </IconButton>
                      )
                    }
                  >
                    <ListItemText
                      primary={servico.nome}
                      secondary={`Qtd: ${servico.quantidade} | Subtotal: R$ ${subtotal.toFixed(2)}`}
                    />
                  </ListItem>
                );
              })
            ) : (
              <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mt: 4 }}>
                Nenhum serviço adicionado ainda.
              </Typography>
            )}
          </List>

          {formData.servicos?.length > 0 && (
            <>
              <Divider sx={{ my: 2 }} />
              <Box
                display="grid"
                // Define duas colunas: 1ª se ajusta ao conteúdo, 2ª ocupa o espaço restante
                gridTemplateColumns="max-content 1fr"
                // Espaçamento entre as linhas e colunas
                rowGap={1}
                columnGap={4}
              >
                {/* Linha 1 */}
                <Typography sx={{ textAlign: 'right' }}>Serviços :</Typography>
                <Typography>
                  {(formData.subTotalServicos || 0).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </Typography>

                {/* Linha 2 */}
                {formData.valorDeslocamento > 0 && (
                  <>
                    <Typography sx={{ textAlign: 'right' }}>Deslocamento :</Typography>
                    <Typography>
                      {(formData.valorDeslocamento || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Typography>
                  </>
                )}

                {/* Linha 3 */}
                {formData.valorIndicacao > 0 && (
                  <>
                    <Typography sx={{ textAlign: 'right' }}>Indicação :</Typography>
                    <Typography>
                      {(formData.valorIndicacao || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </Typography>
                  </>
                )}

                {/* Linha 4 */}
                <Typography sx={{ textAlign: 'right', fontWeight: 'bold' }}>Total Proposta :</Typography>
                <Typography sx={{ fontWeight: 'bold' }}>
                  {(formData.valorServico || 0).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </Typography>
              </Box>
            </>
          )}
        </Stack>
      </Stack>
    </div>
  );
}

export default ServiceData;
